import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { Card, CardContent, CardMedia, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styles from './CardItem.module.less';

const useCardStyle = makeStyles({
  root: {
    boxShadow: '0 10px 17px 0 rgba(0, 0, 0, 0.6)',
    opacity: 0.95,
    margin: '0 18px 24px 0',
    height: 273,
    width: 243
  }
});

const useCardContentStyle = makeStyles({
  root: {
    padding: '8px 8px 24px 8px'
  }
});

const useCardMediaStyle = makeStyles({
  root: {
    width: 227,
    height: 128,
    borderRadius: 4,
    '&:hover': {
      cursor: 'pointer'
    }
  }
});

const CardItem = ({ name, avatarUrl, summary, productIndexPage }) => {
  const cardClasses = useCardStyle();
  const cardMediaClasses = useCardMediaStyle();
  const cardContentClasses = useCardContentStyle();

  const goToDetailsPage = useCallback(() => {
    const generateProductIndexPage = `${window.location.origin}/${productIndexPage}`;
    window.open(generateProductIndexPage);
  }, [productIndexPage]);

  return (
    <Card key={name} classes={cardClasses}>
      <CardContent classes={cardContentClasses}>
        <CardMedia
          src={avatarUrl}
          component='img'
          classes={cardMediaClasses}
          onClick={goToDetailsPage}
        />
        <div className={styles.content}>
          <Tooltip title={name} interactive>
            <div className={styles.name} onClick={goToDetailsPage}>
              {name}
            </div>
          </Tooltip>
          <Tooltip title={summary} interactive>
            <div className={styles.description}>{summary}</div>
          </Tooltip>
        </div>
      </CardContent>
    </Card>
  );
};

CardItem.propTypes = {
  name: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  productIndexPage: PropTypes.string.isRequired
};

export default CardItem;
